import { Form } from 'antd';
import { type FormProviderProps } from 'antd/es/form/context';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { authActions } from '@store/auth/auth.slice';

import { RouteEnum } from '@enum/route.enum';
import { useNewPasswordMutation } from '@hook/auth/auth.hooks';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';

export const useNewPassword = () => {
  const dispatch = useStoreDispatch();
  const navigate = useNavigate();
  const { key = '' } = useParams();
  const [form] = Form.useForm();
  const { error, isLoading } = useStoreSelector((state) => state.auth);
  const { action, state } = useMutation(useNewPasswordMutation(), authActions);

  const onReset: FormProviderProps['onFormFinish'] = (_, { values }) =>
    action({
      password: values.password,
      key,
    });

  useEffect(() => void (state.isSuccess && navigate(RouteEnum.Login.path)), [state.isSuccess]);

  useEffect(() => () => void dispatch(authActions.resetErrors()), []);

  return {
    form,
    error,
    isLoading: isLoading || state.isLoading,
    onReset,
  };
};
